/// <reference path="../../../../typings/index.d.ts" />

module Meevo.SessionTimeout {
    export class SessionTimeoutController {

        private interval: any;
        private displayName: string = '';
        private counter: any;
        private startTime: any;

        static $inject = [
            "$scope",
            "$mdDialog",
            "$translate",
            "session",
            "timeLeft",
            "modalShowTime"
        ];

        constructor(
            private $scope: ng.IScope,
            private $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private session: Meevo.Components.Common.IIdentity,
            protected timeLeft: number,
            protected modalShowTime: number

        ) {
            this.displayName = session.displayName;
            let time = Date.now()
            this.startTime = time - (time - this.modalShowTime)
            this.counter = this.timeLeft;

            this.sessionTimeout();
        }

        sessionTimeout = () => {

            this.interval = setInterval(() => {
                let now = Date.now();
                let elapsedTime = (now - this.startTime) / 1000;
                this.counter = Math.ceil(this.timeLeft - elapsedTime);
                console.log(`elapsedTime: ${elapsedTime} - counter: ${this.counter}`);
                if (this.counter > 0) {
                    this.$scope.$apply(() => { this.counter });
                } else {
                    this.counter = 0;
                    this.countdownZero();
                }

            }, 1000)
        }

        countdownZero = () => {
            this.logout(Meevo.Model.SessionState.Lockout);
        }

        login = () => {
            this.logout(Meevo.Model.SessionState.LogIn);
        }

        logout = (state: Meevo.Model.SessionState = Meevo.Model.SessionState.LogOut) => {
            clearInterval(this.interval);
            return this.$mdDialog.hide(state);
        }

    }

    angular.module("meevo")
        .controller("meevo.sessionTimeout.SessionTimeoutController", SessionTimeoutController);
}